function NoteList() {
    /// <summary>
    /// This object provides common functions for the Widget.Notification.NotificationList.vb <br/>
    /// Author: ARF<br />
    /// Date: 26.11.2015<br />
    /// Copyright ©: EUDT GmbH 2015 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 26.11.2015                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
}
NoteList.prototype = new vcTemplate();

NoteList.prototype.init = function () {
    /// <summary>
    /// This function inits the filter button.
    /// </summary>
  var me = this;
    try {
        if (me.error) { return false; }
        me.showInfo("", "", false);
      
        if (me.Mandatory === false) {
            me.toggleUnseen(me.visual.find('#divBtnFilter'));

            me.visual.find('#divBtnFilter').off('click').on('click', function(e) {
                me.toggleUnseen($(this));
                e.stopPropagation();
            });
        }
        return true;
    } catch (ex) { me.writeError('init', ex); return false; }
};


NoteList.prototype.toggleUnseen = function (obj) {
    /// <summary>
    /// This function toggles the filter button and filters the entries.
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        };
        me.showInfo("", false);
        obj.toggleClass("ui-tabs-active ui-state-active");
        me.filter(obj);

        return true;
    } catch (ex) { me.writeError('toggleUnseen', ex); return false; }
};

NoteList.prototype.filter = function (obj) {
    /// <summary>
    /// This function shows/hides unseen entries and changes the caption of the filter button.
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        };
        me.showInfo("", false);
        me.visual.find('.NoteList').show();

        if (obj.hasClass("ui-state-active")) {
            obj.html(me.resources.showUnreadEntriesOnly);
            me.visual.find(".NoteList:not(:has('.ui-button:visible'))").hide();
        } else {
            obj.html(me.resources.showAllEntries);
        }
        if (me.visual.find('.NoteList:visible').length === 0) {
            me.showInfo(me.resources.noEntriesExist, false);
        }

        return true;
    } catch (ex) { me.writeError('filter', ex); return false; }
};


NoteList.prototype.doEvent = function (event) {
    /// <summary>
    /// This function refreshes the filter after one note has been set as readed.
    /// </summary>
    var me = this;
    try {
      
        if (event.msg === "NOTE_COMMITED") {
            me.filter(me.visual.find('#divBtnFilter'));
        }
        return true;
    } catch (ex) { me.writeError('doEvent', ex); return false; }

};



NoteList.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('.NoteList').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};
